<template>
  <div id="app">
    <div
      v-if="numero"
      class="
        grid
        bg-gradient-to-r
        from-blue-900
        to-blue-500
        grid-cols-1
        md:grid-cols-1
        lg:grid-cols-2
        xl:grid-cols-3
        flex
        bg-black
        w-full
        shadow
      "
    >
      <div>
        <div class="dropdown">
          <img
            width="70px"
            class="flex justify-items-end"
            src="./assets/faviconBlanco.png"
          />
        </div>
        <div class="navbar rounded inline">
          <div class="dropdown">
            <button class="dropbtn justify-start rounded">
              <strong>Maestros</strong>
              <hr id="color" size="4" />
            </button>

            <div class="dropdown-content rounded-xl">
              <div class="row">
                <div class="column font-bold col-span-1">
                  <button class="font-bold">
                    <a href="#">
                      <router-link to="/caracteristicas"
                        >Caracteristicas
                        <hr color="black" size="4"
                      /></router-link>
                    </a>
                  </button>
                  <button
                    @click="
                      cargardatosclientes(),
                        cargardatosdocumentoss(),
                        cargardatosdescuentoss()
                    "
                    class="font-bold"
                  >
                    <a href="#">
                      <router-link to="/clientes"
                        >Clientes
                        <hr color="black" size="4"
                      /></router-link>
                    </a>
                  </button>
                  <button
                    @click="cargardatosproductos(), cargardatosglobal()"
                    class="rounded font-bold bg-white"
                  >
                    <a href="#">
                      <router-link to="/productos"
                        >Productos
                        <hr color="black" size="4" /></router-link
                    ></a>
                  </button>
                  <!-- <button>
                  <a href="#">
                    <router-link to="/consecutivo"
                      >Consecutivo
                      <hr color="black" size="4" /></router-link
                  ></a>
                </button>-->
                  <button @click="cargardatosdocumentos()" class="font-bold">
                    <a href="#">
                      <router-link to="/tipodedocumentos"
                        >Tipos de documentos
                        <hr color="black" size="4" /></router-link
                    ></a>
                  </button>

                  <!-- <button>
                  <a href="#">
                    <router-link to="/"
                      >Usuarios
                      <hr color="black" size="4" /></router-link
                  ></a>
                </button>-->
                  <button
                    @click="cargardatostransportistas()"
                    class="font-bold"
                  >
                    <a href="#">
                      <router-link to="/transportistas"
                        >Transportistas
                        <hr color="black" size="4" /></router-link
                    ></a>
                  </button>
                  <button @click="cargardatosdescuentos()" class="font-bold">
                    <a href="#">
                      <router-link to="/descuentos"
                        >Descuentos
                        <hr color="black" size="4" /></router-link
                    ></a>
                  </button>
                  <button @click="cargardatosreferencias()" class="font-bold">
                    <a href="#">
                      <router-link to="/referencias"
                        >Referencias
                        <hr color="black" size="4" /></router-link
                    ></a>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="mt-6 text-white mx-5">
            <div class="dropdown2"></div>
            <div class="navbar2">
              <div class="dropdown2 mt-1 lg:col-start-2">
                <button class="dropbtn justify-start hover-blue-400">
                  <strong class="">Informes </strong>
                  <hr color="black" size="" id="color" />
                </button>
                <div class="h-4 text-blue-900 text-sm"></div>
                <div class="dropdown-content2 rounded-xl">
                  <div class="row2">
                    <div class="column2 hover:rounded font-bold col-span-1">
                      <button>
                        <a class="font-bold" href="#">
                          <router-link to="/pedidos"
                            >Pedidos
                            <hr color="black" size="4" /></router-link
                        ></a>
                      </button>
                      <button
                        @click="cargardatostransportistas()"
                        class="font-bold"
                      >
                        <a href="#">
                          <router-link to="/Informes"
                            >Informes
                            <hr
                              class="w-full"
                              color="black"
                              size="4" /></router-link
                        ></a>
                      </button>
                      <!--<button @click="cargardatosdescuentos()"  class="font-bold">
                    <a href="#">
                      <router-link to="/descuentos"
                        >Descuentos
                        <hr color="black" size="4" /></router-link
                    ></a>
                  </button>-->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button id="boton" class="dude col-start-4 justify-end grid grid-cols-2">
        <div></div>
        <strong class="font-bold my-5 col-start-2 text-white">
          <a href=".">Cerrar sesión </a>
          <img
            class="p-1 rounded bg-white inline"
            width="25px"
            src="https://image.flaticon.com/icons/png/512/61/61208.png"
            alt=""
          />
          <hr style="width: 70%; text-align: center; margin-left: 25px" />
        </strong>
      </button>
    </div>
    <router-view />

    <!-- This example requires Tailwind CSS v2.0+ -->
  </div>
</template>

<script>
function redireccionar() {
  setTimeout("location.href='.'", 3300000);
}

import { mapState, mapMutations } from "vuex";

export default {
  components: {},
  name: "app",

  data() {
    return {};
  },

  mounted() {
    redireccionar();
  },
  methods: {
    ...mapMutations("clientes", [
      "cargardatosclientes",
      "cargardatosdocumentoss",
      "cargardatosdescuentoss",
    ]),
    ...mapMutations("tipodedocumentos", ["cargardatosdocumentos"]),
    ...mapMutations("transportistas", ["cargardatostransportistas"]),
    ...mapMutations("productos", ["cargardatosproductos", "cargardatosglobal"]),
    ...mapMutations("referencias", ["cargardatosreferencias"]),
    ...mapMutations("descuentos", ["cargardatosdescuentos"]),
    //...mapMutations("pedidos", ["cargardatospedidos"]),
  },
  computed: {
    ...mapState(["numero"]),
  },
};
</script>
<style scoped>
.dude {
  flex: auto;
  justify-content: flex-end;
}
.navbar {
  /* overflow: hidden;*/
  background-color: transparent;
  font-family: Arial;
}
.navbar2 {
  /* overflow: hidden;*/
  background-color: transparent;
  font-family: Arial;
}

/* Links inside the navbar */
.navbar a {
  float: left;
  font-size: 16px;
  color: rgb(255, 255, 255);
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}
.navbar2 a {
  float: left;
  font-size: 16px;
  color: rgb(255, 255, 255);
  text-align: center;
  padding: 14px 16px;
  text-decoration: none;
}

/* The dropdown container */
.dropdown {
  float: left;
  /* overflow: hidden;*/
}

.dropdown2 {
  float: left;
  /*overflow: hidden;*/
}

/* Dropdown button */
.dropdown .dropbtn {
  font-size: 16px;
  border: none;
  outline: none;
  color: white;
  padding: 14px 16px;
  background-color: inherit;
  font: inherit; /* Important for vertical align on mobile phones */
  margin-top: 15px; /* Important for vertical align on mobile phones */
}

.dropdown2 .dropbtn2 {
  font-size: 16px;
  border: none;
  outline: none;
  color: white;
  padding: 14px 16px;
  background-color: inherit;
  font: inherit; /* Important for vertical align on mobile phones */
  margin-top: 14px; /* Important for vertical align on mobile phones */
}

/* Add a red background color to navbar links on hover */
/*.navbar a:hover,
.dropdown:hover .dropbtn {
  background-color: rgba(31, 71, 158, 1);
}
.navbar2 a:hover,
.dropdown2:hover .dropbtn2 {
  background-color: rgba(31, 71, 158, 1);
}

/* Dropdown content (hidden by default) */
.dropdown-content {
  display: none;
  position: absolute;
  /*derecha color */
  background-color: #f9f9f9;
  margin-left: 70px;
  width: 140px;
  left: 0;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.dropdown-content2 {
  display: none;
  position: absolute;
  /*derecha color */
  background-color: #f9f9f9;
  margin-left: 165px;
  width: 135px;
  left: 0;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
}

/* Mega Menu header, if needed */
.dropdown-content .header {
  /*fondo menu*/
  background: transparent;
  /*rgb(13, 40, 150);*/
  padding: 10px;
  color: white;
}
.dropdown-content2 .header {
  /*fondo menu*/
  background: transparent;
  /*rgb(13, 40, 150);*/
  padding: 10px;
  color: white;
}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {
  display: block;
}
.dropdown2:hover .dropdown-content2 {
  display: block;
}

/* Create three equal columns that floats next to each other */
.column {
  float: left;
  width: 33.33%;
  padding: 5px;
  background-color: rgb(255, 255, 255);
  height: 290px;
}
.column2 {
  float: left;
  width: 33.33%;
  padding: 5px;
  background-color: rgb(255, 255, 255);
  height: 255px;
}

/* Style links inside the columns */
.column a {
  float: none;
  color: black;
  padding: 3px;
  text-decoration: none;
  display: block;
  text-align: left;
}
.column2 a {
  float: none;
  color: black;
  padding: 3px;
  text-decoration: none;
  display: block;
  text-align: left;
}

/* Add a background color on hover */
.column a:hover {
  background-color: rgb(192, 192, 192);
  border-radius: 5px;
}
.column2 a:hover {
  background-color: rgb(192, 192, 192);
  border-radius: 5px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
.row2:after {
  content: "";
  display: table;
  clear: both;
}
hr#color {
  border-top: 2px solid rgb(255, 255, 255);
}
</style>